enum ButtonSize {
	EXTRA_LARGE = 'XL',
	LARGE = 'L',
	MEDIUM = 'M',
	SMALL = 'S',
	EXTRA_SMALL = 'XS',
}

export default ButtonSize;